<div class="search-field">
  <fstr-icon class="search-field__icon icon-muted" anchor="icon-search-big"></fstr-icon>

  <input
    class="search-field__input"
    [placeholder]="placeholder() ? placeholder() : ('zoeken-placeholder' | fromDictionary)"
    type="text"
    [(ngModel)]="search"
    (ngModelChange)="searchInput.emit($event)"
    #searchField
  />

  <a
    class="d-md-none search-field__go button button-icon button--xs"
    [ngClass]="type() ? 'button-icon--' + type() : 'button-icon--primary'"
  >
    <fstr-icon class="icon-muted" anchor="icon-arrow-right"></fstr-icon>
  </a>
  <button
    type="submit"
    (click)="searchInput.emit(searchField.value)"
    [ngClass]="type() ? 'button--' + type() : 'button--primary'"
    class="search-field__go button button--md d-none d-md-inline-flex"
  >
    <span>zoeken</span>
  </button>
</div>
